<template>
  <div class="day-events">
    <div class="day-event has-background-white is-border is-margin-bottom-xsmall">
      <div class="columns is-gapless is-marginless">
        <div class="column is-narrow is-padding-left is-padding-right-large has-text-right is-border-right is-flex">
          <div class=" is-self-centered">
            <p class=" has-text-centered">
              <time :datetime="date.format('DD-MMMM-YYYY')">
                <b>{{ event.date | prettyTime }}</b>
              </time><br>
            </p>
            <span class="dot is-medium is-danger">
            </span>
          </div>
        </div>
        <div class="column is-padding is-flex">
          <div class="is-self-centered">
            <div class="is-size-6">
              Auteur: <router-link
                v-if="event.author && event.author.pk === currentUser.pk"
                :to="{name: 'Profil', params: {id: event.author.pk}}">
                Vous
              </router-link>
              <router-link
                v-else-if="event.author && event.author.account && event.author.account.pk === currentUser.account.pk"
                :to="{name: 'UserVue', params: {id: event.author.pk}}">
                {{ event.author.last_name }} {{ event.author.first_name }}
              </router-link>
              <router-link
                v-else-if="isPromoteurDetailsActivated"
                :to="{name: 'PromoteurPresentation', params: {id: event.author.account.pk}}">
                {{ event.author.last_name }} {{ event.author.first_name }} ({{ event.author.account.name }})
              </router-link>
              <span
                v-else>
                {{ event.author.last_name }} {{ event.author.first_name }}
              </span>
            </div>
            <div>
              Rappel :&nbsp; <span class="">"<b>{{ event.title }}</b>"</span>
            </div>
            <div class="is-size-6">
              Pour : <router-link
                v-if="event.user && event.user.pk === currentUser.pk"
                :to="{name: 'Profil', params: {id: event.user.pk}}">
                Vous
              </router-link>
              <router-link
                v-else
                :to="{name: 'UserVue', params: {id: event.user.pk}}">
                {{ event.user.last_name }} {{ event.user.first_name }} <span v-if="event.user && event.user.account && event.user.account.pk !== currentUser.account.pk">({{ event.user.account.name }})</span>
              </router-link>
              <span
                v-if="('program_name' in event.custom_fields && event.custom_fields.program_name && 'program_link' in event.custom_fields && event.custom_fields.program_link) || ('adv_ref' in event.custom_fields && event.custom_fields.adv_ref && 'adv_link' in event.custom_fields && event.custom_fields.adv_link)"> - Source :
                <router-link
                  :to="{name: 'AdvInfos', params: {id: event.custom_fields.adv_link}}"
                  v-if="'adv_ref' in event.custom_fields && event.custom_fields.adv_ref && 'adv_link' in event.custom_fields && event.custom_fields.adv_link">
                  ADV {{ event.custom_fields.adv_ref }}
                </router-link>
                <span v-if="'program_name' in event.custom_fields && event.custom_fields.program_name && 'program_link' in event.custom_fields && event.custom_fields.program_link && 'adv_ref' in event.custom_fields && event.custom_fields.adv_ref && 'adv_link' in event.custom_fields && event.custom_fields.adv_link">/</span>
                <router-link
                  :to="{name: 'ProgramVue', params: {id: event.custom_fields.program_link}}"
                  v-if="'program_name' in event.custom_fields && event.custom_fields.program_name && 'program_link' in event.custom_fields && event.custom_fields.program_link">
                  Programme : {{ event.custom_fields.program_name }}
                </router-link>
              </span>
            </div>
            <div
              class="is-size-6"
              v-if="event.custom_fields.contactName && event.custom_fields.contactPk">
              Contact : <router-link :to="{name: 'ContactVue', params: {id: event.custom_fields.contactPk}}">
                {{ event.custom_fields.contactName }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="column is-padding is-narrow is-self-centered">
          <div class="field is-grouped">
            <div class="control is-relative">
              <div class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger">
                  <button
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    class="button is-actions is-circle">
                    <span class="icon is-small is-size-4"><i class="far fa-ellipsis-v"></i></span>
                  </button>
                </div>
                <div
                  id="dropdown-menu"
                  role="menu"
                  class="dropdown-menu">
                  <div class="dropdown-content has-text-left">
                    <a
                      @click="updateReminder()"
                      class="dropdown-item"><span class="icon"><i class="fas fa-pencil"></i></span><span>Modifier rappel</span></a>
                    <a
                      @click="deleteReminder()"
                      class="dropdown-item has-text-danger"><span class="icon"><i class="fas fa-trash"></i></span><span>Supprimer rappel</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="event.note"
        class="day-eventactions is-border-top is-border--dashed">
        <div class="dayeventactions-actions">
          <div class="columns is-gapless is-padding">
            <p class="column is-narrow">
              <b>Note :</b>
            </p> <p
              class="column is-padding-left-xsmall"
              v-html="event.note"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Error, Quickview } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'CalendarReminderItems',
  mixins: [Error, Quickview],
  props: {
    event: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['accounts']),
    date () {
      let date = moment(this.event.date)
      if (date && date.isValid()) return date
      else return null
    },
    isPromoteurDetailsActivated () {
      if (!this.event || !this.event.author || !this.event.author.account) {
        return false
      }
      const accountPk = this.event.author.account.pk
      if (!accountPk) {
        return false
      }
      const account = this.accounts.find(account => account.pk === accountPk)
      return account && account.promoteur_details_activated ? account.promoteur_details_activated : false
    }
  },
  methods: {
    confirmDelete () {
      return this.$swal({
        title: 'Suppression rappel',
        text: 'Le rappel ne sera plus consultable.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    async deleteReminder () {
      let r = await this.confirmDelete()
      if (r.value) {
        let eventPk = this.event.pk
        let key = moment(this.event.date).format('DD/MM/YYYY')
        try {
          await this.$api.delete(this.$resources.REMINDER, eventPk)
          this.$store.commit('removeCalendarEvent', { eventPk, key, type: 'reminders' })
          this.$toasted.global.success('Le rappel à été supprimé.')
        } catch (err) {
          console.log(err)
          this.handleError(err)
        }
      }
    },
    updateReminder () {
      let params = {
        source: this.event,
        type: 'reminder'
      }
      this.openCalendarNewAction(params)
    }
  }
}
</script>
